/* Mobile PDP: pin a buy bar to the bottom and lift the fit signals up beside
   the size selector. Progressive enhancement only - it drives the theme's own
   form, so Rebuy/analytics fire exactly as before. */
(function () {
	function init() {
		if (!document.body.classList.contains('template-product')) return;
		if (document.querySelector('.ltl-buybar')) return;

		var form = document.querySelector('form[action*="/cart/add"]:not(.installment)');
		var realAtc = form && form.querySelector('.single-add-to-cart-button, button[type="submit"]');
		var info = document.querySelector('[id^="ProductInfo-"]') || document.body;
		var h1 = document.querySelector('h1.product-title, h1');
		if (!form || !realAtc || !h1) return;

		/* ---------- 1. fit signals under the size selector ---------- */
		var fieldsets = [].slice.call(document.querySelectorAll('fieldset.product-form__input'));
		var sizeFs = fieldsets.filter(function (f) {
			if (!f.offsetParent) return false;
			var lg = f.querySelector('legend');
			if (lg && /size/i.test(lg.textContent)) return true;
			var l = f.querySelector('label');
			// caps use S/M and M/L; some ranges use numeric sizes
			return !!l && /^(XXS|XS|S|M|L|XL|XXL|[2-4]XL|S\/M|M\/L|\d{1,2})$/i.test((l.textContent || '').trim());
		})[0];

		if (sizeFs) {
			var box = document.createElement('div');
			box.className = 'ltl-fit';
			function findSizing() {
				var nodes = document.querySelectorAll('script[data-oke-metafield-data]');
				for (var i = 0; i < nodes.length; i++) {
					var d, agg, ar;
					try { d = JSON.parse(nodes[i].textContent || '{}') } catch (e) { continue }
					agg = d.reviewAggregate || d;
					ar = (agg.attributeRatings || []).filter(function (a) { return /sizing/i.test(a.title) })[0];
					if (!ar) continue;
					return { ar: ar, n: agg.ratingAndReviewCount || agg.reviewCount || d.reviewCount || (d.chatAssistant && d.chatAssistant.reviewCount) };
				}
				return null;
			}
			function renderSizing() {
				if (box.querySelector('.ltl-fit__size')) return true;
				var hit = findSizing();
				if (!hit) return false;
				var v = Number(hit.ar.value) || 0;
				var verdict = Math.abs(v) <= 0.5 ? (hit.ar.midLabel || 'True to size')
					: v < 0 ? (hit.ar.minLabel || 'Runs small') : (hit.ar.maxLabel || 'Runs large');
				var row = document.createElement('div');
				row.className = 'ltl-fit__size';
				row.innerHTML = '<span class="ltl-fit__dot"></span><strong></strong><span class="ltl-fit__n"></span>';
				row.querySelector('strong').textContent = verdict;
				if (hit.n) row.querySelector('.ltl-fit__n').textContent = '— from ' + hit.n + ' reviews';
				box.insertBefore(row, box.firstChild);
				return true;
			}
			if (!renderSizing()) {
				var tries = 0;
				var poll = setInterval(function () { if (renderSizing() || ++tries > 30) clearInterval(poll) }, 400);
			}
			var rows = [].slice.call(document.querySelectorAll('collapsible-row, .product__accordion'));
			var descRow = rows.filter(function (r) {
				var s = r.querySelector('summary');
				return s && /description|details|fit/i.test(s.textContent || '');
			})[0];
			if (descRow) {
				var sum = descRow.querySelector('summary');
				if (sum && /wearing size|oversized|relaxed|gsm/i.test(descRow.textContent || '')) {
					var done = false;
					var cands = [].slice.call(sum.querySelectorAll('*'));
					for (var c = 0; c < cands.length && !done; c++) {
						if (cands[c].children.length === 0 && /^\s*description\s*$/i.test(cands[c].textContent || '')) {
							cands[c].textContent = 'Fit & sizing'; done = true;
						}
					}
					if (!done) {
						for (var k = 0; k < sum.childNodes.length; k++) {
							var nd = sum.childNodes[k];
							if (nd.nodeType === 3 && /^\s*description\s*$/i.test(nd.nodeValue || '')) { nd.nodeValue = 'Fit & sizing'; break }
						}
					}
				}
				descRow.classList.add('ltl-moved-accordion');
				box.appendChild(descRow);
			}
			sizeFs.insertAdjacentElement('afterend', box);
		}

		/* ---------- 2. sticky buy bar ---------- */
		var bar = document.createElement('div');
		bar.className = 'ltl-buybar';
		bar.innerHTML =
			'<img class="ltl-buybar__img" alt="">' +
			'<div class="ltl-buybar__txt">' +
				'<div class="ltl-buybar__name"></div>' +
				'<div class="ltl-buybar__meta"><span class="ltl-buybar__price"></span>' +
				'<span class="ltl-buybar__size"></span></div>' +
			'</div>' +
			'<button type="button" class="ltl-buybar__btn">Add to cart</button>';
		document.body.appendChild(bar);

		var img = document.querySelector('.product-single__media img, .product-images img, .product-information img');
		if (img && img.currentSrc) bar.querySelector('.ltl-buybar__img').src = img.currentSrc;
		bar.querySelector('.ltl-buybar__name').textContent = h1.textContent.trim();

		var priceEl = info.querySelector('.price, [class*="price"]');
		function syncPrice() {
			if (!priceEl) return;
			// Read ONLY currency amounts - the container also holds a hidden unit-price
			// element (a stray "/") and theme labels like "Save 40%".
			var raw = priceEl.textContent.replace(/\s+/g, ' ').trim();
			var found = raw.match(/\$[\d,]+(?:\.\d{2})?/g) || [];
			var uniq = [];
			for (var i = 0; i < found.length; i++) {
				if (found[i] !== '$0.00' && uniq.indexOf(found[i]) < 0) uniq.push(found[i]);
			}
			var text;
			if (uniq.length) {
				text = uniq.slice(0, 2).join(' ');
			} else {
				// Unreleased drops render "$0.00 / COMING SOON" - the words are the
				// useful part, so surface those rather than a meaningless $0.00.
				text = raw.replace(/\$[\d,]+(?:\.\d{2})?/g, '').replace(/[\/·\-]+/g, ' ')
					.replace(/\s+/g, ' ').trim().slice(0, 24);
			}
			bar.querySelector('.ltl-buybar__price').textContent = text;
		}

		var sizeChosen = false;

		// Do NOT uncheck the theme's default radio - product.js does
		// input:checked.value and throws on null. Mark the fieldset instead so CSS
		// renders every size as unselected until the shopper actually chooses.
		function clearDefault() {
			if (!sizeFs || sizeChosen) return;
			sizeFs.classList.add('ltl-nosel');
		}
		function needSize() {
			sizeFs.scrollIntoView({ behavior: 'smooth', block: 'center' });
			sizeFs.classList.add('ltl-needsize');
			setTimeout(function () { sizeFs.classList.remove('ltl-needsize') }, 1600);
		}
		function hasSize() { return sizeChosen && !!sizeFs.querySelector('input:checked') }
		function markChosen() { sizeChosen = true; if (sizeFs) sizeFs.classList.remove('ltl-nosel') }
		var accel = document.querySelector('.shopify-payment-button');
		function syncAccel() {
			if (!accel) return;
			accel.style.pointerEvents = hasSize() ? '' : 'none';
			accel.style.opacity = hasSize() ? '' : '0.4';
		}
		if (sizeFs) {
			clearDefault();
			setTimeout(clearDefault, 400);
			setTimeout(clearDefault, 1200);
			var gate = function (e) {
				if (hasSize()) return;
				e.preventDefault(); e.stopImmediatePropagation();
				needSize();
			};
			realAtc.addEventListener('click', gate, true);
			form.addEventListener('submit', gate, true);
			syncAccel();
		}
		function syncSize() {
			var el = bar.querySelector('.ltl-buybar__size');
			if (!sizeFs) { el.textContent = ''; return }
			if (!sizeChosen) { el.textContent = '· Select size'; syncAccel(); return }
			var picked = sizeFs.querySelector('input:checked');
			var lbl = picked && sizeFs.querySelector('label[for="' + picked.id + '"]');
			var t = lbl ? lbl.textContent.trim() : (picked ? picked.value : '');
			el.textContent = t ? '· Size ' + t : '· Select size';
			syncAccel();
		}
		syncPrice(); syncSize();
		document.addEventListener('change', function (e) {
			if (sizeFs && sizeFs.contains(e.target)) { markChosen(); syncSize(); setTimeout(syncPrice, 250) }
		});
		if (sizeFs) sizeFs.addEventListener('click', function () { markChosen(); syncSize() });

		bar.querySelector('.ltl-buybar__btn').addEventListener('click', function () {
			if (sizeFs && !hasSize()) { needSize(); return }
			realAtc.click();
		});

		if ('IntersectionObserver' in window) {
			new IntersectionObserver(function (es) {
				bar.classList.toggle('is-in', !es[0].isIntersecting);
			}, { rootMargin: '0px 0px -60px 0px' }).observe(realAtc);
		} else { bar.classList.add('is-in') }

		/* ---------- 3. free-shipping nudge (threshold from Shopify: $200) ---------- */
		fetch('/cart.js', { credentials: 'same-origin' })
			.then(function (r) { return r.json() })
			.then(function (c) {
				var gap = 20000 - (c.total_price || 0);
				if (!c.item_count || gap <= 0) return;
				var s = document.createElement('div');
				s.className = 'ltl-buybar__ship';
				s.textContent = "You're $" + (gap / 100).toFixed(2) + ' away from FREE EXPRESS SHIPPING';
				bar.appendChild(s);
			}).catch(function () {});
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
	else init();
})();
